import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-block-preloader',
	templateUrl: './block-preloader.component.html',
	styleUrls: ['./block-preloader.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class BlockPreloaderComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/block-preloader/block-preloader.component.ts